import onEditSearchCondition from './onEditSearchCondition'
import onSearch from './onSearch'

const ReceptionistAction = {
  onEditSearchCondition,
  onSearch
}

export default ReceptionistAction
